import { deLocalizeUrl, localizeUrl } from '@sohanscript/i18n/runtime';
import { TopLoader } from '@sohanscript/ui/animated/top-loader';
import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';
import type { ReactNode } from 'react';
import { InternalServerError } from './components/internal-server-error';
import { NotFoundPage } from './components/not-found';
import { queryClient } from './lib/tanstack-query/query-client';
import ReactQuery from './lib/tanstack-query/react-query';
import { trpcUtils } from './lib/trpc/utils';
import { routeTree } from './routeTree.gen';
import type { RouterContext } from './types';

export function getRouter() {
	const context: RouterContext = { queryClient: queryClient, trpc: trpcUtils };

	const router = createTanStackRouter({
		routeTree,
		context,
		scrollRestoration: true,
		defaultPreload: 'intent',
		defaultStaleTime: 5000,
		defaultPreloadStaleTime: 0,
		defaultViewTransition: false,
		defaultNotFoundComponent: NotFoundPage,
		defaultPendingComponent: TopLoader,
		defaultErrorComponent: InternalServerError,
		rewrite: {
			input: ({ url }) => deLocalizeUrl(url),
			output: ({ url }) => localizeUrl(url),
		},

		Wrap: (props: { children: ReactNode }) => {
			return <ReactQuery>{props.children}</ReactQuery>;
		},
	});

	setupRouterSsrQueryIntegration({ router, queryClient: context.queryClient });

	return router;
}

declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
